export default __webpack_public_path__ + "static/media/logo.3df6760a.svg";